import Vue from 'vue';
import VueRouter from 'vue-router';

import Home from './home.vue';
import Auth from './components/auth/auth.vue';
import Login from './components/auth/login.vue';
import ReqChangePassword from './components/auth/reqChangePassword.vue';
import ChangePassword from './components/auth/changePassword.vue';
import Register from './components/auth/register.vue';
import Painel from './painel.vue';

const Banco = () => import(/* webpackChunkName: "js/banco" */ './components/banco/banco.vue')
const IndexBanco = () => import(/* webpackChunkName: "js/banco" */ './components/banco/indexBanco.vue')
const EditBanco = () => import(/* webpackChunkName: "js/banco" */ './components/banco/editBanco.vue')

const Menu = () => import(/* webpackChunkName: "js/menu" */ './components/menu/menu.vue')
const IndexMenu = () => import(/* webpackChunkName: "js/menu" */ './components/menu/indexMenu.vue')
const EditMenu = () => import(/* webpackChunkName: "js/menu" */ './components/menu/editMenu.vue')

const Enums = () => import(/* webpackChunkName: "js/enum" */ './components/enum/enums.vue')
const IndexEnum = () => import(/* webpackChunkName: "js/enum" */ './components/enum/indexEnum.vue')
const EditEnum = () => import(/* webpackChunkName: "js/enum" */ './components/enum/editEnum.vue')

const Combo = () => import(/* webpackChunkName: "js/combo" */ './components/combo/combo.vue')
const IndexCombo = () => import(/* webpackChunkName: "js/combo" */ './components/combo/indexCombo.vue')
const EditCombo = () => import(/* webpackChunkName: "js/combo" */ './components/combo/editCombo.vue')

const Agregado = () => import(/* webpackChunkName: "js/agregado" */ './components/agregado/agregado.vue')
const IndexAgregado = () => import(/* webpackChunkName: "js/agregado" */ './components/agregado/indexAgregado.vue')
const EditAgregado = () => import(/* webpackChunkName: "js/agregado" */ './components/agregado/editAgregado.vue')

const Role = () => import(/* webpackChunkName: "js/role" */ './components/role/role.vue')
const IndexRole = () => import(/* webpackChunkName: "js/role" */ './components/role/indexRole.vue')
const EditRole = () => import(/* webpackChunkName: "js/role" */ './components/role/editRole.vue')

const User = () => import(/* webpackChunkName: "js/user" */ './components/user/user.vue')
const IndexUser = () => import(/* webpackChunkName: "js/user" */ './components/user/indexUser.vue')
const EditUser = () => import(/* webpackChunkName: "js/user" */ './components/user/editUser.vue')

const Relatorio = () => import(/* webpackChunkName: "js/relatorio" */ './components/relatorio/relatorio.vue')
const IndexRelatorio = () => import(/* webpackChunkName: "js/relatorio" */ './components/relatorio/indexRelatorio.vue')
const EditRelatorio = () => import(/* webpackChunkName: "js/relatorio" */ './components/relatorio/editRelatorio.vue')

const ExecRelatorio = () => import(/* webpackChunkName: "js/execrelatorio" */ './components/execrelatorio/execRelatorio.vue')
const ExecListarRelatorio = () => import(/* webpackChunkName: "js/execrelatorio" */ './components/execrelatorio/execListarRelatorio.vue')
const ExecAbrirRelatorio = () => import(/* webpackChunkName: "js/execrelatorio" */ './components/execrelatorio/execAbrirRelatorio.vue')

const ControleScript = () => import(/* webpackChunkName: "js/scpt" */ './components/controle_script/controlescript.vue')
const IndexControleScript = () => import(/* webpackChunkName: "js/scpt" */ './components/controle_script/indexControleScript.vue')
const EditControleScript = () => import(/* webpackChunkName: "js/scpt" */ './components/controle_script/editControleScript.vue')
const ExecControleScript = () => import(/* webpackChunkName: "js/scpt" */ './components/controle_script/execControleScript.vue')

const Formulario = () => import(/* webpackChunkName: "js/formulario" */ './components/formulario/formulario.vue')
const IndexFormulario = () => import(/* webpackChunkName: "js/formulario" */ './components/formulario/indexFormulario.vue')
const EditFormulario = () => import(/* webpackChunkName: "js/formulario" */ './components/formulario/editFormulario.vue')

const ExecFormulario = () => import(/* webpackChunkName: "js/execformulario" */ './components/execformulario/execFormulario.vue')
// const ExecListarFormulario = () => import(/* webpackChunkName: "js/execformulario" */ './components/execformulario/execListarFormulario.vue')
const ExecAbrirFormulario = () => import(/* webpackChunkName: "js/execformulario" */ './components/execformulario/execAbrirFormulario.vue')
const ExecEditarFormulario = () => import(/* webpackChunkName: "js/execformulario" */ './components/execformulario/execEditarFormulario.vue')

// teste de split do app.js. Desse modo os arquivos são gerados e carregados separadamente, deixando o tamanho do app menor
//const AgendamentoComando = () => import(/* webpackChunkName: "js/agendamentocomando" */ './components/agendamentocomando/agendamentocomando.vue')
//const IndexAgendamentoComando = () => import(/* webpackChunkName: "js/agendamentocomando" */ './components/agendamentocomando/indexAgendamentoComando.vue')
//const EditAgendamentoComando = () => import(/* webpackChunkName: "js/agendamentocomando" */ './components/agendamentocomando/editAgendamentoComando.vue')

const Empresa = () => import(/* webpackChunkName: "js/empresa" */ './components/empresa/empresa.vue')
const EditEmpresa = () => import(/* webpackChunkName: "js/empresa" */ './components/empresa/editEmpresa.vue')
const EditConfiguracao = () => import(/* webpackChunkName: "js/empresa" */ './components/empresa/editConfiguracao.vue')

const EditParametro = () => import(/* webpackChunkName: "js/parametro" */ './components/parametro/editParametro.vue')

const TipoItem = () => import(/* webpackChunkName: "js/tipoitem" */ './components/tipoItem/tipoItem.vue')
const IndexTipoItem = () => import(/* webpackChunkName: "js/tipoitem" */ './components/tipoItem/indexTipoItem.vue')
const EditTipoItem = () => import(/* webpackChunkName: "js/tipoitem" */ './components/tipoItem/editTipoItem.vue')

const Item = () => import(/* webpackChunkName: "js/item" */ './components/item/item.vue')
const IndexItem = () => import(/* webpackChunkName: "js/item" */ './components/item/indexItem.vue')
const EditItem = () => import(/* webpackChunkName: "js/item" */ './components/item/editItem.vue')

const EmpresaProtocolo = () => import(/* webpackChunkName: "js/empresaprotocolo" */ './components/empresaProtocolo/empresaProtocolo.vue')
const IndexEmpresaProtocolo = () => import(/* webpackChunkName: "js/empresaprotocolo" */ './components/empresaProtocolo/indexEmpresaProtocolo.vue')
const EditEmpresaProtocolo = () => import(/* webpackChunkName: "js/empresaprotocolo" */ './components/empresaProtocolo/editEmpresaProtocolo.vue')

const Protocolo = () => import(/* webpackChunkName: "js/protocolo" */ './components/protocolo/protocolo.vue')
const IndexProtocolo = () => import(/* webpackChunkName: "js/protocolo" */ './components/protocolo/indexProtocolo.vue')
const EditProtocolo = () => import(/* webpackChunkName: "js/protocolo" */ './components/protocolo/editProtocolo.vue')

Vue.use(VueRouter)

const routes = [
  { path: '/', component: Home, name: 'home' },
  { path: '/banco', component: Banco,
  children:[
    {path: '',component: IndexBanco, name: 'indexBanco'},    
    {path: 'new',component: EditBanco, name: 'newBanco'},
    {path: ':id/edit',component: EditBanco, name: 'editBanco'}
  ]},
  { path: '/menu', component: Menu,
  children:[
    {path: '',component: IndexMenu, name: 'indexMenu'},    
    {path: 'new',component: EditMenu, name: 'newMenu'},
    {path: ':id/edit',component: EditMenu, name: 'editMenu'}
  ]},
  { path: '/enum', component: Enums,
  children:[
    {path: '',component: IndexEnum, name: 'indexEnum'},    
    {path: 'new',component: EditEnum, name: 'newEnum'},
    {path: ':id/edit',component: EditEnum, name: 'editEnum'}
  ]},
  { path: '/combo', component: Combo,
  children:[
    {path: '',component: IndexCombo, name: 'indexCombo'},    
    {path: 'new',component: EditCombo, name: 'newCombo'},
    {path: ':id/edit',component: EditCombo, name: 'editCombo'}
  ]},
  { path: '/agregado', component: Agregado,
  children:[
    {path: '',component: IndexAgregado, name: 'indexAgregado'},    
    {path: 'new',component: EditAgregado, name: 'newAgregado'},
    {path: ':id/edit',component: EditAgregado, name: 'editAgregado'}
  ]},
  { path: '/role', component: Role,
  children:[
    {path: '',component: IndexRole, name: 'indexRole'},    
    {path: 'new',component: EditRole, name: 'newRole'},
    {path: ':id/edit',component: EditRole, name: 'editRole'}
  ]},
  { path: '/usuario', component: User,
  children:[
    {path: '',component: IndexUser, name: 'indexUser'},    
    {path: 'new',component: EditUser, name: 'newUser'},
    {path: ':id/edit',component: EditUser, name: 'editUser'}
  ]},
  { path: '/relatorio', component: Relatorio,
  children:[
    {path: '',component: IndexRelatorio, name: 'indexRelatorio'},    
    {path: 'new',component: EditRelatorio, name: 'newRelatorio'},
    {path: ':id/edit',component: EditRelatorio, name: 'editRelatorio'},    
  ]},
  { path: '/execrelatorio', component: ExecRelatorio,
  children:[    
    {path: '',component: ExecListarRelatorio, name: 'execListarRelatorio'},
    {path: ':id/abrir',component: ExecAbrirRelatorio, name: 'execAbrirRelatorio'}
  ]},
  {
    path: '/controlescript', component: ControleScript,
    children: [
      {path: '', component: IndexControleScript, name: 'indexControleScript'},
      {path: 'new', component: EditControleScript, name: 'newControleScript'},
      {path: ':id/edit', component: EditControleScript, name: 'editControleScript'}
      // {path: 'executa', component: ExecControleScript, name: 'execControleScript'}
  ]},
  {
    path: '/execcontrolescript', component: ExecControleScript, name: 'execControleScript'    
  },
  { path: '/formulario', component: Formulario,
  children:[
    {path: '',component: IndexFormulario, name: 'indexFormulario'},    
    {path: 'new',component: EditFormulario, name: 'newFormulario'},
    {path: ':id/edit',component: EditFormulario, name: 'editFormulario'},    
  ]},
  { path: '/f', component: ExecFormulario,
  children:[    
    // {path: '',component: ExecListarFormulario, name: 'execListarFormulario'},
    {path: ':formulario_tag',component: ExecAbrirFormulario, name: 'execAbrirFormulario'},
    {path: ':formulario_tag/new',component: ExecEditarFormulario, name: 'execNovoFormulario'},
    {path: ':formulario_tag/:id/edit',component: ExecEditarFormulario, name: 'execEditarFormulario'}
  ]},
  { path: '/login', component: Auth, name: 'auth',
  children:[    
    {path: '',component: Login, name: 'login'},
    {path: 'reqchangepassword',component: ReqChangePassword, name: 'reqChangePassword'},
    {path: 'changepassword',component: ChangePassword, name: 'changePassword'},
    {path: 'register',component: Register, name: 'register'}       
  ]},
  { path: '/empresa', component: Empresa,
  children:[    
    {path: 'edit',component: EditEmpresa, name: 'editEmpresa'},
    {path: 'configuracao',component: EditConfiguracao, name: 'editConfiguracao'},
  ]},
  { path: '/painel', component: Painel,
  children:[        
    {path: ':id/abrir',component: ExecAbrirRelatorio, name: 'painel'}
  ]},
  {path: '/parametro/:id/edit',component: EditParametro, name: 'editParametro'},


  //business rules
  { path: '/tipoitem', component: TipoItem,
  children:[
    {path: '',component: IndexTipoItem, name: 'indexTipoItem'},    
    {path: 'new',component: EditTipoItem, name: 'newTipoItem'},
    {path: ':id/edit',component: EditTipoItem, name: 'editTipoItem'}
  ]},
  { path: '/item', component: Item,
  children:[
    {path: '',component: IndexItem, name: 'indexItem'},    
    {path: 'new',component: EditItem, name: 'newItem'},
    {path: ':id/edit',component: EditItem, name: 'editItem'}
  ]},
  { path: '/empresaprotocolo', component: EmpresaProtocolo,
  children:[
    {path: '',component: IndexEmpresaProtocolo, name: 'indexEmpresaProtocolo'},    
    {path: 'new',component: EditEmpresaProtocolo, name: 'newEmpresaProtocolo'},
    {path: ':id/edit',component: EditEmpresaProtocolo, name: 'editEmpresaProtocolo'}
  ]},
  { path: '/protocolo', component: Protocolo,
  children:[
    {path: '',component: IndexProtocolo, name: 'indexProtocolo'},    
    {path: 'new',component: EditProtocolo, name: 'newProtocolo'},
    {path: ':id/edit',component: EditProtocolo, name: 'editProtocolo'}
  ]},
  

  //404 redireciona para raiz
  {path: '*', redirect: '/'}
]

//export default new VueRouter({mode: 'history', routes})  
//modo history sem 'hash'
//dando problema nas children routes, com o laravel, entrando em loop infinito

export default new VueRouter({mode: 'hash', routes})
